module.exports = __webpack_public_path__ + "img/denmark-pneumonia-male.756dd376.png";